import { PASSWORD_MATCHES } from '@uplift/constants';
import { l10nEnService } from '@uplift/services';
import { ObjectSchema, object, string } from 'yup';

export type InviteForm = {
  email: string;
  password: string | null;
};

export const getInviteFormValidation = (l10n: typeof l10nEnService): ObjectSchema<InviteForm> => object({
  email: string()
    .email(l10n.validations.invalidEmail)
    .required(l10n.validations.loginForm.emailBlank),
  password: string()
    .nullable()
    .max(125, l10n.validations.passwordMax)
    .required(l10n.validations.requiredPass)
    .matches(PASSWORD_MATCHES, l10n.validations.passwordMatches),
});
